import React from 'react';
import { NoContent } from "@avaya/neo-react"

const NoData = (props) => {
    return <div className={`no-data ${props.size}-div`}>
        <NoContent text={props?.text ?? "No Data"} /></div>
};

export default NoData;